import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { STORAGE_KEY } from "config/const";
import { postAuthRefresh } from "./user.request";

// 상태 변수
let isRefreshing = false;
let failedQueue: {
  resolve: (value: AxiosResponse<any>) => void;
  reject: (reason?: any) => void;
  config: AxiosRequestConfig;
}[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(async ({ resolve, reject, config }) => {
    if (error) {
      reject(error);
    } else {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
      resolve(await axios(config));
    }
  });

  failedQueue = [];
};

export const refreshAndRetry = async (
  originalRequest: AxiosRequestConfig
): Promise<AxiosResponse> => {
  return new Promise(async (resolve, reject) => {
    if (isRefreshing) {
      // refresh 중이면 queue에 넣고 기다리기
      failedQueue.push({ resolve, reject, config: originalRequest });
      return;
    }

    isRefreshing = true;

    const refreshToken = localStorage.getItem(STORAGE_KEY.refreshTokenKey);
    if (!refreshToken) {
      isRefreshing = false;
      return reject(false);
    }

    try {
      const { data } = await postAuthRefresh({ refreshToken });

      const newAccessToken = data.data?.payload?.accessToken;
      const newRefreshToken = data.data?.payload?.refreshToken;

      if (newAccessToken) {
        localStorage.setItem(STORAGE_KEY.accessTokenKey, newAccessToken);
      }
      if (newRefreshToken) {
        localStorage.setItem(STORAGE_KEY.refreshTokenKey, newRefreshToken);
      }

      processQueue(null, newAccessToken);

      originalRequest.headers = {
        ...originalRequest.headers,
        Authorization: `Bearer ${newAccessToken}`,
      };
      resolve(axios(originalRequest));
    } catch (error) {
      processQueue(error, null);

      // 실패 시 모든 요청 실패 처리
      localStorage.removeItem(STORAGE_KEY.accessTokenKey);
      localStorage.removeItem(STORAGE_KEY.refreshTokenKey);
      window.location.href = "/login";

      reject(error);
    } finally {
      isRefreshing = false;
    }
  });
};
